const AboutModal = ({ aboutModalRef }) => {
  return (
    <>
      {/* Result Modal */}
      <div className="modal fade" ref={aboutModalRef} id="modalAbout" tabIndex="-1" aria-labelledby="modalAboutTitle" aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content px-4 py-3">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="modalAboutTitle">About Us</h1>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              <div className="modal-subcontent">
                <h2>Welcome to <b>TripHalal</b> – Your Personalized Halal Travel Consultant</h2>
                <p>TripHalal is a proud subsidiary of <b>SiapHalal</b>, committed to providing tailored travel solutions that align with your halal lifestyle. Whether you're planning a solo adventure, a family getaway, or a business trip, we ensure that your journey meets your values and expectations.</p>

                <h2>Our Mission</h2>
                <p>We are driven by the spirit of growing the halal market worldwide, making it easier for everyone to achieve their halal travel goals with confidence and convenience.</p>

                <h2>What We Offer</h2>
                <ul>
                  <li><b>AI-Powered Halal Travel Consultation</b> – Get personalized itinerary recommendations that align with your preferences and halal requirements.</li>
                  <li><b>Reliable Booking Options</b> – Enjoy a hassle-free booking experience for flights, hotels, and activities through our trusted travel agency partners.</li>
                  <li><b>Simple & Straightforward Platform</b> – Our easy-to-use platform ensures a smooth and hassle-free experience, allowing you to plan and book your halal travel with just a few clicks.</li>
                </ul>

                <p>Let TripHalal be your trusted companion in discovering the world, the halal way!</p>

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default AboutModal